import { Reveal, Overline } from "../Reveal";

const PROFILE = [
  { k: "Age", v: "32 — 58" },
  { k: "Aesthetic", v: "Discreet logo" },
  { k: "Lifestyle", v: "Resort-to-City" },
];

export default function Slide04Customer() {
  return (
    <section className="slide bg-[var(--ais-cream)]" data-testid="slide-04">
      <div className="min-h-screen flex items-center px-6 md:px-16 lg:px-24 py-24">
        <div className="w-full max-w-6xl mx-auto">
          <Reveal>
            <Overline>04 — Target Customer</Overline>
          </Reveal>
          <Reveal delay={1}>
            <div className="hairline w-16 my-8" />
          </Reveal>
          <Reveal delay={2}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.75rem] text-[var(--ais-espresso)] leading-[1.05] tracking-[-0.01em] font-light max-w-3xl">
              Designed for the <em className="italic">discerning</em>
              <br />
              Gulf consumer.
            </h2>
          </Reveal>

          <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--ais-gold-soft)] border border-[var(--ais-gold-soft)]">
            {PROFILE.map((p, i) => (
              <Reveal key={p.k} delay={3 + i}>
                <div className="bg-[var(--ais-cream)] p-8 md:p-10 h-full flex flex-col items-center justify-center text-center min-h-[220px]">
                  <div className="font-sans text-[0.65rem] tracking-luxe uppercase text-[var(--ais-leather)]">
                    {p.k}
                  </div>
                  <div className="mt-6 font-serif text-3xl md:text-4xl text-[var(--ais-espresso)] italic font-light leading-tight">
                    {p.v}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={7}>
            <div className="mt-16 flex items-center gap-4 opacity-70">
              <div className="h-px w-12 bg-[var(--ais-gold)]" />
              <span className="font-serif text-base md:text-lg tracking-[0.35em] text-[var(--ais-espresso)]">
                AIS
              </span>
              <span className="font-sans text-[0.6rem] tracking-luxe uppercase text-[var(--ais-text)]">
                Artistic Italian Shoes
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
